var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_62_1165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9501 88.9041C71.1683 88.9041 72.9666 87.1058 72.9666 84.8876C72.9666 82.6693 71.1683 80.8711 68.9501 80.8711C66.7318 80.8711 64.9336 82.6693 64.9336 84.8876C64.9336 87.1058 66.7318 88.9041 68.9501 88.9041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9501 107.516C81.4473 107.516 91.5783 97.3851 91.5783 84.8879C91.5783 72.3907 81.4473 62.2598 68.9501 62.2598C56.453 62.2598 46.322 72.3907 46.322 84.8879C46.322 97.3851 56.453 107.516 68.9501 107.516Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9501 130.143C93.9444 130.143 114.206 109.881 114.206 84.8871C114.206 59.8928 93.9444 39.6309 68.9501 39.6309C43.9558 39.6309 23.6938 59.8928 23.6938 84.8871C23.6938 109.881 43.9558 130.143 68.9501 130.143Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9503 152.773C106.442 152.773 136.835 122.38 136.835 84.8883C136.835 47.3968 106.442 17.0039 68.9503 17.0039C31.4588 17.0039 1.06592 47.3968 1.06592 84.8883C1.06592 122.38 31.4588 152.773 68.9503 152.773Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.95 84.888L133.565 20.2734",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.802 20.0359L152.414 15.0464L138.792 1.43555L133.802 20.0359Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 153,
    fill: "white",
    transform: "translate(0.5 0.337891)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.995e0d1fc19e54e9c96ffdedec3e6bab.svg";
export { ForwardRef as ReactComponent };